import {
	Container,
	ContainerPadding,
	Text,
	TokenTextAppearance,
	Image,
	TextAlignment,
	CTA,
	TokenTextColor,
	Richtext,
	AspectRatioContainer,
} from '@volkswagen-onehub/components-core';
import React from 'react';
import { NormalizedVoucher } from '@esportal/portal-service';
import { PortalContext } from '../../../../context/portal-context';
import { vwBenefitsRedirect } from '../../../../helpers/benefits-helper';
import { useBenefitsTracker } from '../hooks/use-benefits-tracker';
import { normalizeMarkdownForRichtext, createRichtextTextOverrides } from '../../../../helpers/common-helpers';

export const VouchersPopupLayerContent: React.FC<{
	vouchersPopupData: NormalizedVoucher;
	vwBankLayer: () => void;
}> = ({ vouchersPopupData, vwBankLayer }) => {
	const { navigationService, userInteractionService } = React.useContext(PortalContext);
	const { trackVoucherinLayerClick } = useBenefitsTracker();

	const layerCta = vouchersPopupData.layer?.cta;
	const isvwBankUrl = layerCta?.src ? /(bedesa-vw\.ceca\.es|volkswagenbank\.es|vwfs\.es)/.test(layerCta.src) : false;

	return (
		<Container
			padding={{
				right: ContainerPadding.dynamic0100,
				bottom: ContainerPadding.dynamic0100,
				left: ContainerPadding.dynamic0100,
			}}
			horizontalAlign={'center'}
			wrap={'always'}
		>
			<AspectRatioContainer data-testid="aspect-ratio-container" ratio="16:9">
				<Image
					src={vouchersPopupData.layer?.imageUrl}
					alt="Imagen bono"
					style={{ borderRadius: '16px', objectFit: 'cover' }}
				/>
			</AspectRatioContainer>
			<Container
				horizontalAlign={'center'}
				wrap={'always'}
				padding={{
					top: ContainerPadding.dynamic0130,
				}}
			>
				<Text textAlign={TextAlignment.center}>
					<Richtext
						markdown={normalizeMarkdownForRichtext(vouchersPopupData.layer?.title)}
						color={TokenTextColor.primary}
						overrides={createRichtextTextOverrides(TokenTextAppearance.headline300, TokenTextColor.primary)}
					/>
				</Text>

				<Container
					wrap={'always'}
					padding={{
						top: ContainerPadding.dynamic0130,
					}}
					verticalAlign={'center'}
					horizontalAlign={'center'}
				>
					<Text textAlign={TextAlignment.center}>
						<Richtext
							markdown={normalizeMarkdownForRichtext(vouchersPopupData.layer?.description)}
							color={TokenTextColor.primary}
							overrides={createRichtextTextOverrides(TokenTextAppearance.bigcopy100, TokenTextColor.primary)}
						/>
					</Text>
				</Container>

				{vouchersPopupData.layer?.modoEmpleo && (
					<Container
						wrap={'always'}
						padding={{
							top: ContainerPadding.dynamic0130,
						}}
						verticalAlign={'center'}
						horizontalAlign={'center'}
					>
						<Text appearance={TokenTextAppearance.bigcopy100} textAlign={TextAlignment.center} bold>
							¿Cómo puedes utilizarlo?
						</Text>

						<Text textAlign={TextAlignment.center}>
							<Richtext
								markdown={normalizeMarkdownForRichtext(vouchersPopupData.layer?.modoEmpleo)}
								color={TokenTextColor.primary}
								overrides={createRichtextTextOverrides(TokenTextAppearance.bigcopy100, TokenTextColor.primary)}
							/>
						</Text>
					</Container>
				)}

				{layerCta?.src && layerCta.label && (
					<Container
						padding={{
							top: ContainerPadding.dynamic0130,
						}}
						verticalAlign={'center'}
						horizontalAlign={'center'}
					>
						<CTA
							tag="button"
							aria-label="CTA vouchers redirect"
							size="large"
							emphasis="primary"
							onClick={() => {
								trackVoucherinLayerClick(vouchersPopupData);

								if (isvwBankUrl) {
									vwBankLayer();
								} else {
									vwBenefitsRedirect(layerCta.src, navigationService, userInteractionService);
								}
							}}
						>
							<Text> {layerCta.label}</Text>
						</CTA>
					</Container>
				)}

				<Container
					wrap={'always'}
					padding={{
						top: ContainerPadding.dynamic0130,
					}}
					verticalAlign={'center'}
					horizontalAlign={'center'}
				>
					<Text textAlign={TextAlignment.center}>
						<Richtext
							markdown={normalizeMarkdownForRichtext(vouchersPopupData.legalText)}
							color={TokenTextColor.tertiary}
							overrides={createRichtextTextOverrides(TokenTextAppearance.copy100, TokenTextColor.tertiary)}
						/>
					</Text>
				</Container>
			</Container>
		</Container>
	);
};
